import { ConfigProvider } from "antd";
import { antdTheme } from "../themes/antdTheme";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@base/routes/baseRoutes";
import CommonStyles from "@components/CommonStyles";
import { useTranslation } from "react-i18next";
import { getAntdLocale } from "@base/language/antdLocale";

export default function SettingProvider() {
  // Subscribes to i18next, so switching the language re-renders antd with the matching locale.
  const { i18n } = useTranslation();

  return (
    // No click "wave": it flashes a glow around the button, which the flat buttons should not have.
    <ConfigProvider theme={antdTheme} locale={getAntdLocale(i18n.resolvedLanguage)} wave={{ disabled: true }}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ConfigProvider>
  );
}
